<template>
  <div @click="goDetail" class="course-card">
    <span
      class="tag-btn"
      :style="{ background: resultMap[info.results_id] }"
      v-if="showResultTag && info.results_id&& info.results_name"
    >
      {{ info.results_name }}
    </span>
    <div class="course-card-cover">
      <img :src="info.course_cover_url || require('@/assets/images/common/course_cover.png')" />
    </div>
    <div class="course-card-info">
      <div class="top">
        <div class="course-name text-overflow" :title="info.course_name.length > 15 ? info.course_name : ''">{{ info.course_name }}</div>
        <!-- <div class="course-info">
          <div class="item">
            <div class="val">{{ info.students_num || 0 }}</div>
            <div class="label">选课人数</div>
          </div>
          <div class="item">
            <div class="val">{{ info.publish_resources_num || 0 }}</div>
            <div class="label">学习资源</div>
          </div>
          <div class="item">
            <div class="val">{{ info.video_record || 0 }}</div>
            <div class="label">课堂录像</div>
          </div>
        </div> -->
      </div>
      <div class="bottom">
        <div class="teacher">
          <!-- <img class="avatar" :src="info.avatar || require('@/assets/images/user_avatar.jpg')" /> -->
          <div class="name texts" :title="info.lecturer.length> 10 ? info.lecturer : ''">{{ info.lecturer }}</div>
          <div class="name ml">{{info.organ_name}}</div>
        </div>
        <div class="time">
          <span>{{ info.students_num }}人参加</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatDate } from '@/plugins/utils'
import { handleLogin } from '@/plugins/utils'
import { ref, computed, watch, onMounted, unref } from 'vue'

const props = defineProps({
  info: {
    type: Object
  },
  userInfo: {
    type: Object,
    default: null
  },
  authType: Number,
  showResultTag: Boolean,
  resultMap: Object
})
const goDetail = () => {
  if (unref(props.authType) == 2 && !unref(props.userInfo)) {
    handleLogin()
  } else {
    props.info.course_url && window.open(unref(props.info.course_url))
  }
}
</script>

<style lang="scss" scoped>
.course-card {
  width: 100%;
  height: 236px !important;
  margin-bottom: 0px !important;
  background: #F7F8FA;
  // border: 1px solid #dddddd;
  margin-bottom: 30px;
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.5s;
  position: relative;

  &:hover {
    transform: translate(0, -5px);
    box-shadow: 0 2px 12px rgba(160, 160, 160, 0.23);
    transition: all 0.5s;
    background-color: #fff !important;
  }

  .tag-btn {
    position: absolute;
    top: 13px;
    left: 13px;
    font-size: 12px;
    padding: 5px 10px;
    background-color: var(--el-color-primary);
    color: #fff;
    min-width: 60px;
    text-align: center;

    /* 梯形形状 */
    clip-path: polygon(5% 100%, 100% 100%, 91% 0%, 0% 0%);
  }
  .course-card-cover{
    height: 147px !important;
  }
  .course-card-info{
    padding:12px 8px 16px 8px;
  }
  &-cover {
    height: 185px;
    overflow: hidden;

    img {
      transition: all 0.5s;
      width: 100%;
      height: 100%;
    }
  }

  &-info {
    box-sizing: border-box;
    padding: 12px 8px;

    .top {

      // border-bottom: 1px dashed $--border-color;
      // padding-bottom: 20px;
      .course-name {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #1D2129;
      }

      .course-info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .val {
            line-height: 20px;
            font-size: 18px;
            font-weight: 700;
            color: #153e77;
          }

          .label {
            font-size: 14px;
            font-weight: normal;
            color: #666666;
          }
        }
      }
    }

    .bottom {
      padding-top: 8px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .teacher {
        display: flex;
        align-items: center;

        .avatar {
          width: 19px;
          height: 19px;
          border: 1px solid $--border-color;
          border-radius: 50%;
          margin-right: 5px;
        }

        .name {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #1D2129;
        }
        .texts{
          width: auto;
          max-width: 56px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .time {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 11px;
        color: #86909C;
      }
    }
  }
}

.ml {
  margin-left: 8px;
  width: auto;
  max-width: 190px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
